<script setup lang="ts">
import { reactive, ref, toRaw } from 'vue';

import KBtn from '@/components/btns/KBtn.vue';
import CustomerCodeAutocompleteField from '@/components/fields/CustomerCodeAutocompleteField.vue';
import useForm from '@/composables/useForm';
import { requiredValidationRule } from '@/helpers/validationRules';

export interface InitialData {
  customer?: string;
}

export interface ValidData {
  customer: string;
}

export interface Props {
  loading?: boolean;
  initialData?: InitialData;
}
const props = withDefaults(defineProps<Props>(), {
  loading: false,
  initialData: () => ({}),
});
const emit = defineEmits<{
  submit: [formData: ValidData];
}>();

const formData = reactive<InitialData>({});
const isValid = ref(true);

const { form, handleSubmit } = useForm(props, formData, () => {
  emit('submit', toRaw(formData) as ValidData);
});
</script>

<template>
  <v-form
    ref="form"
    v-model="isValid"
    validate-on="lazy"
    :class="$style.kpiReportSearchForm"
    data-testid="kpiReportSearchForm"
    @submit.prevent="handleSubmit"
  >
    <CustomerCodeAutocompleteField
      v-model="formData.customer"
      size="large"
      :disabled="props.loading"
      :rules="[requiredValidationRule]"
      :class="$style.field"
      @keydown.enter="handleSubmit"
    />
    <KBtn
      type="submit"
      size="lg"
      prepend-icon="mdi-magnify"
      :loading="props.loading"
      :class="$style.submit"
    >
      Search
    </KBtn>
  </v-form>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.kpiReportSearchForm {
}
  .field {
    width: 17.5rem;
    display: inline-block;
    vertical-align: top;
  }
  .field {
    margin-right: 1.5rem;
    margin-bottom: 0.5rem;
  }
  .submit {
    margin-bottom: calc(0.5rem + 22px);
  }
</style>
